<div class="text-xs text-center text-uppercase" style="transform: rotate(270deg)" [style.width.px]="height">
  <div *ngIf="!rental" [ngClass]="labelClass">{{ label }}</div>

  <ng-container *ngIf="rental">
    <div class="text-white bg-info parent-label" *ngIf="rental | isParentRental">Parent</div>
    <div class="text-info bg-secondary-info child-label" *ngIf="rental | isChildRental">Child</div>

    <div class="text-white bg-indigo parent-label" *ngIf="rental | isMainUnit">Multi</div>
    <div class="text-indigo bg-secondary-indigo child-label" *ngIf="rental | isSubunit">Sub</div>
  </ng-container>
</div>
